import { getAuth } from "firebase/auth";
import { LoaderFunctionArgs, redirect } from "react-router-dom";
import * as APITypes from "src/API";
import { apiClient, MessageDetailsLoaderResult } from "~/services/apiClient";

const EMPTY_MESSAGE: APITypes.Message = {
  __typename: "Message",
  id: "",
  title: "",
  content: "",
  createdAt: "",
  updatedAt: "",
  _version: 0,
  _lastChangedAt: 0,
};

export const MessageDetailsPageLoader = async ({
  request,
  params,
}: LoaderFunctionArgs) => {
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) return redirect("/signup");

  const messageID = params.messageID || "";

  const response = await apiClient.loader<MessageDetailsLoaderResult>(
    "message-details",
    {
      id: messageID,
      tenantName: user!.displayName ?? undefined,
    },
  );

  if (!response.success || !response.data) {
    return {
      user: {
        userID: user!.uid,
        tenantID: user!.tenantId ?? "",
        tenantName: user!.displayName ?? "",
      },
      message: EMPTY_MESSAGE,
    };
  }

  return response.data;
};

export type MessageDetailsPageLoaderType = {
  user: {
    userID: string;
    tenantID: string;
    tenantName: string;
  };
  message: APITypes.Message;
};
